export enum SurveyVariants {
  FRAME = "frame",
  EMULATOR = "emulator",
}
